const MENUS_KEY = 'menus'
const USER_INFO_KEY = 'userInfo'
const IS_COLLAPSE_KEY = 'isCollapse'
const TOKEN_KEY = 'kakacloAdminToken'

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  return window.localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  return window.localStorage.removeItem(TOKEN_KEY)
}

export function getMenus() {
  return JSON.parse(window.localStorage.getItem(MENUS_KEY))
}

export function setMenus(menus) {
  return window.localStorage.setItem(MENUS_KEY, JSON.stringify(menus))
}

export function removeMenus() {
  return window.localStorage.removeItem(MENUS_KEY)
}

export function getUserInfo() {
  return JSON.parse(window.localStorage.getItem(USER_INFO_KEY))
}

export function setUserInfo(userInfo) {
  return window.localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return window.localStorage.removeItem(USER_INFO_KEY)
}

export function getIsCollapse() {
  return JSON.parse(window.localStorage.getItem(IS_COLLAPSE_KEY))
}

export function setIsCollapse(status) {
  return window.localStorage.setItem(IS_COLLAPSE_KEY, JSON.stringify(status))
}

export function removeIsCollapse() {
  return window.localStorage.removeItem(IS_COLLAPSE_KEY)
}

// nav tabs
export function getTabs() {
  console.log('getTabs')
  return JSON.parse(window.localStorage.getItem('tabs'))
}

export function setTabs(tabs) {
  return window.localStorage.setItem('tabs', JSON.stringify(tabs) || tabs)
}

export function removeTabs() {
  return window.localStorage.removeItem('tabs')
}


export function getActiveTab() {
  return window.localStorage.getItem('activeTab')
}
